export const THEMES = {
    default: {
      primaryColor: "#1571b9",
      primarylightColor: "#d2daf3",
      menuSelectColor:'#0050c7',
      menuSelectbgColor:'#0050c724',
      bodyBgColor:'#f8fbff',
      whiteColor:'#ffffff',
      secondaryHoverbg:'#f5f5f5',
      popupwindowheadbg:'#2e77ae',
      buttonbackgroundcolor: '#0054A8',
     textprimarycolor: '#000E1C',
     textsecondarycolor: '#353c43',
    textteritorycolor: '#80878e',
    iconlight1color: '#909090',
    iconlight2color:'#b0b0b0',
    icondarkcolor: '#666666',
    linkcolor:'#0054A8',
    backgroundprimarycolor: '#F6F6F8',
    backgroundsecondarycolor: '#F3F3F6',
    backgroundteritorycolor: '#EAEAEF',
    bordercolor: '#D3D1D1',
    inputbordercolor: '#D3D1D1',
    listbackgoundhover:'#1571b917',
    listcolor:'#1571b9',
    },
    steelblue:{
      primaryColor:'#1571b9',
      primarylightColor: "#b5dcff",
      menuSelectColor:'#0050c7',
      menuSelectbgColor:'#0050c724',
      bodyBgColor:'#f8fbff',
      whiteColor:'#ffffff',
      secondaryHoverbg:'#ebf5ff',
      popupwindowheadbg:'#2e77ae',
      buttonbackgroundcolor: '#0054A8',
     textprimarycolor: '#000E1C',
     textsecondarycolor: '#353c43',
    textteritorycolor: '#80878e',
    iconlight1color: '#909090',
    iconlight2color:'#b0b0b0',
    icondarkcolor: '#666666',
    linkcolor:'#0054A8',
    backgroundprimarycolor: '#F6F6F8',
    backgroundsecondarycolor: '#F3F3F6',
    backgroundteritorycolor: '#EAEAEF',
    bordercolor: '#D3D1D1',
    inputbordercolor: '#D3D1D1',
    listbackgoundhover:'#1571b917',
    listcolor:'#1571b9',
    },

    black: {
      primaryColor: "#000000",
      primarylightColor: "#a3a3a3",
      menuSelectColor:'#ffffff',
      menuSelectbgColor:'#000000',
      bodyBgColor:'#f1f1f1',
      whiteColor:'#ffffff',
      secondaryHoverbg:'#f5f5f5',
      popupwindowheadbg:'#000'
    }

  };
